









































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import user from '@/store/modules/user';
import store from '@/store';
import checkout from '@/store/modules/checkout';
import ui from '@/store/modules/ui';
import { Address } from '@/store/models';
import addressNormalizer, { copyAddressData, getAddresKeys } from '@/commons/addressNormalizer';
import AddressForm from '@/components/Address/Form.vue';
import { Validator } from 'vee-validate';
import Modal from '@/components/UI/Modal.vue';
import { pick } from 'lodash';

@Component({
  components: {
    AddressForm,
    Modal,
  },
})
export default class AddressList extends Vue {
  @Inject() public $validator!: Validator;
  // tutorial: le prop sono proprietà che il componente padre passa al figlio.
  // Il flusso dei dati è sempre e solo dal padre verso il figlio.
  // Se il componente figlio vuole ritornare il dato indietro lo deve fare attraverso
  // l'emissione di un evento (this.$emit) a cui il padre registrerà lo specifico event handler.
  // Qui torna utile Vuex che espone uno stato globale accessibile da tutti i componenti
  @Prop() private type!: string;

  private deletingAddress = 0;

  private mounted() {
    this.addresses.forEach((address) => {
      if (this.isSelected(address)) {
        this.selectAddress(address);
      }
    });
  }

  get selectedAddressId(): number | undefined {
    return checkout.selectedAddressId[this.type];
  }

  set selectedAddressId(val: number | undefined) {
    checkout.setSelectedAddressId({type: this.type, id: val});
  }

  get addresses(): Address[] {
    return user.customer.addresses;
  }

  get editAddress(): any {
    return user.editAddress;
  }

  private extraAddress(address: Address) {
    const findedAttr = address.custom_attributes.find((att: any) => att.attribute_code === 'tdy_extra_address');
    return findedAttr ? findedAttr.value : null;
  }

  get editMode(): string {
    return user.editAddressMode;
  }

  get isRegionOptional(): boolean {
    return store.state.options.countrysettings.is_region_optional;
  }

  private setEditMode(mode: string, selectedId: number|undefined) {
    user.setEditMode({mode, selectedId});
  }

  private toggleDeleteAddressModal(dir: boolean, addressId: any = undefined) {
    if (dir) {
      this.deletingAddress = addressId as unknown as number;
      ui.openModal('deleteAddressModal')
    } else {
      ui.closeModal('deleteAddressModal')
    }
  }

  private deleteAddress(addressId: number) {
    user.deleteAddress(addressId).then(() => {
      ui.closeModal('deleteAddressModal')
    });
  }

  private getAddressbookLabel(address: any): string {
    const found = address.custom_attributes.find((att: any) => att.attribute_code === 'tdy_addressbooklabel');
    return found ? found.value : '';
  }

  private canDelete(address: Address): boolean {
    const addressKeys = getAddresKeys();
    const addressHash = JSON.stringify(pick(address, addressKeys));

    const selectedBillingAddr = user.customer.addresses.find((addr) => addr.id == checkout.selectedAddressId.billing);
    const selectedShippingAddr = user.customer.addresses.find((addr) => addr.id == checkout.selectedAddressId.shipping);
    const billingHash = selectedBillingAddr ? JSON.stringify(pick(selectedBillingAddr, addressKeys)) : '';
    const shippingHash = selectedShippingAddr ? JSON.stringify(pick(selectedShippingAddr, addressKeys)) : '';

    const shippingQuoteHash = JSON.stringify(pick(checkout.shippingAddress, addressKeys));
    const billingQuoteHash = JSON.stringify(pick(checkout.billingAddress, addressKeys));

    return addressHash !== shippingHash && addressHash !== billingHash
      && addressHash !== shippingQuoteHash && addressHash !== billingQuoteHash;
  }

  private isSelected(address: Address) {
    if (this.selectedAddressId && address.id === this.selectedAddressId) {
      return true;
    } else if (!this.selectedAddressId) {
      const addressKeys = getAddresKeys();
      const addressHash = JSON.stringify(pick(address, addressKeys));
      if (this.type === 'shipping' && checkout.shippingAddress.firstname) {
        const quoteHash = JSON.stringify(pick(checkout.shippingAddress, addressKeys));
        return quoteHash === addressHash;
      }
      if (this.type === 'billing' && checkout.billingAddress.firstname) {
        const quoteHash = JSON.stringify(pick(checkout.billingAddress, addressKeys));
        return quoteHash === addressHash;
      }

      const defaultShipping = user.shippingAddress;
      const defaultBilling = user.billingAddress;
      if (this.type === 'shipping' && defaultShipping) {
        const check = address.id !== defaultShipping.id;
        return check;
      }
      if (this.type === 'billing' && defaultBilling) {
        const check = address.id !== defaultBilling.id;
        return check;
      }
    }

    return false;
  }

  private selectAddress(address: Address) {
    this.setEditMode('', undefined);
    if (address.id) {
      this.selectedAddressId = address.id;
    }
  }

  private selectAddressClickHandler(address: Address) {
    user.setCurrentSelectedAddress(address.id as unknown as number);
    this.selectAddress(address);
    this.$emit('addressSelected', address);
  }
}
